import Header from './components/Header';
import Footer from './components/Footer';
import Experiences from './components/Experiences';
import Projects from './components/Projects';

function App() {
  return (
    <div className="App">
      <Header />
      <Experiences />
      <Projects />
      <Footer />
    </div>
  );
}

export default App;
